const apiUrl = process.env.REACT_APP_API || 'http://localhost:8000';
export const endpoint = apiUrl;
export const endpointV1 = apiUrl + '/v1/';
export const endpointV2 = apiUrl + '/v2/';
